import React from "react";
import { base_path, domain } from "./api";

export default function JsonDump(props) {
        return <pre style={{"background-color": "#fff",  "border": "2px solid black"}}>{JSON.stringify(props.data, null, 4)}</pre>
}

export function getClassName(item){
    return item.props.className ? "-"+item.props.className : "";
}

export function language(){
    return window.location.search.split('id=')[1]
}

export function translate(text){
    const tranlates = require("../translates.json") ? require("../translates.json") : null;
    const lang      = getCurrentLanguage();


    switch(lang){
        case "es":
            return text;
        case "eu":
            return tranlates[lang][text] || text;
        default:
            return text;
    }
}

export function getCurrentLocationByLanguage(lang){
    return "/"+window.location.pathname;
}

export function getCurrentLanguage(){
    var basePath = '/cautividad';
    var path = window.location.pathname.replace(basePath, '')
    const lang = path.split('/')[1];
    let validLang = false;
    getLanguages().map(
        res => res === lang ? validLang = true : false
    );
    if(validLang) return lang;
    return getLanguages()[0];
}

export function getLanguages(){
    return ['es', 'eu'];
}

export function getApiCurrentLanguage(){
    switch(getCurrentLanguage()){
        case 'es': return 'spa';
        case 'eu': return 'eus';
        default: return 'spa';
    }
}

export function isSafari(){
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {return true}
    return false;
}

export function languageRoute(lang, route = ''){
    if (lang){
        var langIsset = false
        getLanguages().map(
            lg => {
                if (window.location.href.includes(lg)) langIsset = true
            }
        )
        if (!langIsset){
            if (window.location.href[window.location.href.length-1] === '/') return window.location.href+lang
            return window.location.href+'/'+lang
        }
        if (window.location.href.includes('/'+getCurrentLanguage()+'/')) return window.location.href.replace('/'+getCurrentLanguage()+'/', '/'+lang+'/')
        if (window.location.href.includes('/'+getCurrentLanguage())) return window.location.href.replace('/'+getCurrentLanguage(), '/'+lang+'/')
    }
    return window.location.host+route;
}

export function getPath(){
    const location = window.location;
    let path = location.pathname+location.search+location.hash;
    return path.replace(languageRoute(''), '');
}

export function isValidLanguage(){
    const lang = window.location.pathname.split('/')[1];
    let validLang = false;
    getLanguages().map(
        res => res === lang ? validLang = true : null
    );
    return validLang;
}

export function getUrlByLanguage(url){
    if(url.split('/')[1] === getCurrentLanguage()){
        return url;
    }
    return "/"+getCurrentLanguage()+url;
}

export function cleanArray(items){
    return [...new Set(items.map(e => JSON.stringify(e)))].map(e => JSON.parse(e))
}

export function pdfReader(pdf, action = '_blank'){
    window.open(domain+pdf, action);
}

export function getImage(img){
    //return domain+"/dedalo/lib/dedalo/component_image/html/component_image_viewer.php?f="+img+"?"+new Date().getTime()
    return domain+img+"?"+new Date().getTime()
}

export const linkTo = (url) => {
    return '/'+getCurrentLanguage()+url
}